module.exports = __webpack_public_path__ + "img/project-3.abdfd116.jpg";